import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const storefrontShortcutsBarAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StorefrontShortcutsBarView, Permission.StorefrontShortcutsBarModify],
  featureToggles: [FeatureToggle.storefrontShortcutsBar],
}
